import { styled } from '../../../theme/stitches.config';

export const SMPStandingsRow = styled.withConfig({ componentId: 'CommonWidget', displayName: 'StandingsRow' })('div', {
  display: 'flex',
  fd: 'row',
  jc: 'start',
  ai: 'center',
  py: '8px',
  '@bp0': {
    pr: '$5',
  },
  '@bp2': {
    pr: '28px',
  },
  '@bp4': {
    pr: '38px',
  },
  bc: '$rowBackgroundColor',
  position: 'relative',
  mb: '1px',
  boxSizing: 'border-box',
  '&::before': {
    content: '',
    width: '4px',
    top: '4%',
    height: '90%',
    position: 'absolute',
    borderRadius: '0 $3 $3 0',
  },
  variants: {
    rule: {
      top: {
        '&::before': {
          background: '$top',
        },
      },
      topplayoff: {
        '&::before': {
          background: '$topPlayoff',
        },
      },
      relegation: {
        '&::before': {
          background: '$relegationColor',
        },
      },
      relegationplayoff: {
        '&::before': {
          background: '$relegationPlayoff',
        },
      },
      promotion: {
        '&::before': {
          background: '$promotion',
        },
      },
      promotionplayoff: {
        '&::before': {
          background: '$promotionPlayoff',
        },
      },
      championshipplayoff: {
        '&::before': {
          background: '$championshipPlayoff',
        },
      },
      tiertwo: {
        '&::before': {
          background: '$tierTwo',
        },
      },
      tiertwoplayoff: {
        '&::before': {
          background: '$tierTwoPlayoff',
        },
      },
      none: {
        '&::before': {
          background: 'inherit',
        },
      },
    },
  },
});
